import { t } from "@lingui/macro";

export const PrivacyPolicyPage = () => (
  <main className="container py-24">
    <h1 className="text-4xl font-bold">{t`Privacy Policy`}</h1>
  </main>
);
